module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/DailyPrecipitation100/Tokyo_DailyPrecipitation100_MRI_RCP85_End.png";